import { render, staticRenderFns } from "./FieFormWizard.vue?vue&type=template&id=35623828&"
import script from "./FieFormWizard.vue?vue&type=script&lang=js&"
export * from "./FieFormWizard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports